import { Box, Card, CardContent, CircularProgress, Typography } from '@mui/material'
import { ReactNode } from 'react'

interface StatePanelProps {
  title: string
  description?: string
  action?: ReactNode
}

export const LoadingStatePanel = ({ title = 'Loading', description }: Partial<StatePanelProps>) => {
  return (
    <Card>
      <CardContent sx={{ py: 6, textAlign: 'center' }}>
        <CircularProgress size={34} />
        <Typography variant="h6" sx={{ mt: 2 }}>
          {title}
        </Typography>
        {description && (
          <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
            {description}
          </Typography>
        )}
      </CardContent>
    </Card>
  )
}

export const EmptyStatePanel = ({ title, description, action }: StatePanelProps) => {
  return (
    <Card>
      <CardContent sx={{ py: 6, textAlign: 'center' }}>
        <Typography variant="h6">{title}</Typography>
        {description && (
          <Typography variant="body2" color="text.secondary" sx={{ mt: 1, mb: action ? 3 : 0 }}>
            {description}
          </Typography>
        )}
        {action && <Box>{action}</Box>}
      </CardContent>
    </Card>
  )
}
